import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/root/_services/authentication.service';
import { StorageService } from 'src/app/root/_services/storage.service';
import { containsInArray } from '../_utils/general-util';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	private jwtHelper: JwtHelperService = new JwtHelperService();

	constructor(private translateService: TranslateService, private router: Router, private authService: AuthenticationService, private storageService: StorageService) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		//const currentUser = this.storageService.getItem('current_user');
		const token = this.storageService.getItemPlain('access_token');
		const lingua = this.storageService.getItemPlain('language');
		if(lingua)
			this.translateService.use(lingua);
		let currentUser = null;
		if (token)
			currentUser = this.jwtHelper.decodeToken(token).user;
		if (currentUser) {
			
			// check if route is restricted by role
			//if (next.data.roles && next.data.roles.indexOf(currentUser.profilo) === -1) {
			// role not authorised so redirect to home page
			//this.router.navigate([next.data.noAuthRedirect]);
			//return false;
			//}
			if (next.data.roles && !containsInArray(next.data.roles, currentUser.auth_profilo)) {
				this.authService.logout(false)
					.subscribe(
						data => {
							this.router.navigate(['/login']);
							this.authService.clearClientSession();
						},
						error => {
							this.router.navigate(['/login']);
							this.authService.clearClientSession();
						}
					);
				return false;
			}
			else if (currentUser.auth_profilo == "P" && !next.data.is_wizard && !currentUser.profilo_valido) {
				this.router.navigate(['/wizard']);
				return false;
			}
			// authorised so return true
			return true;
		}

		// not logged in so redirect to login page with the return url
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}

}
